import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export function useTickets(status) {
  const [tickets, setTickets] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/support/tickets", { params: status && status !== "all" ? { status } : {} });
      setTickets(data);
    } catch (e) {
      setTickets([]);
    }
    setLoaded(true);
  }, [status]);
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);
  return { tickets, loaded, load };
}
